// extracted by mini-css-extract-plugin
export default {"main-content":"NoticesAndBills_main-content__GnDmR","tableContainer":"NoticesAndBills_tableContainer__rpcuF","float-right":"NoticesAndBills_float-right__nZrgY"};